import CustomerAttachmentsApp from "customerAttachments/App"
import MobileApp from "mobile/AppWithContext"

import SalesApp from "./views/App"

const AppRoute = () => {
  const { hostname } = window.location

  const host = hostname.split(".")[0]

  switch (host) {
    case "order-doc":
    case "order-doc-local": {
      return <CustomerAttachmentsApp />
    }
    case "sales-portal-mobile":
    case "mobile": {
      return <MobileApp />
    }
    case "sales-portal":
    case "sales":
    default: {
      return <SalesApp />
    }
  }
}

export default AppRoute
